import Swal from 'sweetalert2';

/**
 * Feedback padrão para toda ação "simulada" do Maestro (sem persistência real — seção 31 do épico).
 * Usa o mesmo SweetAlert2 já adotado no restante da plataforma, como toast não-bloqueante.
 */
export const dispararAcaoSimulada = (mensagem: string): void => {
  Swal.fire({
    toast: true,
    position: 'top-end',
    icon: 'success',
    title: mensagem,
    showConfirmButton: false,
    timer: 2200,
    timerProgressBar: true,
  });
};
